import { DownOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextCaption } from '@carboncopyco/ui';
import classNames from 'classnames';

export type AdvancedSettingsToggleButtonProps = {
  isAdvancedSettingVisible: boolean;
  toggle: () => void;
};

export const AdvancedSettingsToggleButton = ({
  isAdvancedSettingVisible,
  toggle,
}: AdvancedSettingsToggleButtonProps) => {
  return (
    <div
      role="button"
      className="flex items-center cursor-pointer"
      onClick={toggle}
    >
      <TextCaption
        color="text-ds-natural-600"
        label="Advanced settings"
      />
      <div className="ml-1">
        <div
          className={classNames(
            'ml-auto transition flex',
            isAdvancedSettingVisible ? 'rotate-180' : 'rotate-0'
          )}
        >
          <DownOutlineIcon
            size={20}
            color={ColorHex.natural600}
          />
        </div>
      </div>
    </div>
  );
};
